import SEO from "@/components/SEO";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <>
      <SEO title="Sayfa Bulunamadı — Pratik Teknoloji" description="Aradığınız sayfa bulunamadı." />
      <section className="min-h-[90vh] bg-[#0A0A0A] text-white flex items-center pt-20 relative overflow-hidden">
        <div className="grain absolute inset-0 opacity-40"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#FF3B30]/15 rounded-full blur-[160px]"></div>
        <div className="relative max-w-3xl mx-auto px-6 text-center">
          <div className="font-display text-[120px] md:text-[220px] font-extrabold tracking-[-0.05em] leading-none text-white">
            4<span className="text-[#FF3B30]">0</span>4
          </div>
          <h1 className="font-display text-3xl md:text-5xl font-bold text-white mt-4">Sayfa bulunamadı.</h1>
          <p className="mt-5 text-white/60 text-lg">Aradığınız sayfa taşınmış veya kaldırılmış olabilir.</p>
          <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#FF3B30] text-white px-7 py-4 font-semibold hover:bg-white hover:text-[#0A0A0A] transition-colors">
            Ana sayfaya dön
          </Link>
        </div>
      </section>
    </>
  );
}
